import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoSolicitud: [],
  },

  getters: {
    getTipoSolicitud: (state) => state.tipoSolicitud,
  },

  mutations: {
    SET_TIPO_SOLICITUD(state, tipoSolicitud) {
      state.tipoSolicitud = tipoSolicitud;
    },
  },

  actions: {
    async fetchTipoSolicitud({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/cattipoSolicitud')
        .then((response) => {
          commit('SET_TIPO_SOLICITUD', response.data.data);
        });
    },
  },
};
